import { HeadCell } from '@dfl/mui-admin-layout';
import { createdATColumn, emailColumn, phoneColumn } from 'modules/common/constants';
import { userFullNameColumn, userRolesColumn, userStatusColumn } from 'modules/security/users/constants/user.columns';
import ProviderUserRowActions from 'modules/security/user-providers/components/ProviderUserRowActions/ProviderUserRowActions';

export const warehouseUsersActionsColumn: HeadCell = {
  field: 'actions',
  sortable: false,
  width: 100,
  headerName: 'actions',
  disablePadding: true,
  component: ProviderUserRowActions,
};

export const warehouseUsersColumns = [
  userFullNameColumn('/security/providers-users/user'),
  emailColumn,
  phoneColumn,
  userStatusColumn,
  userRolesColumn,
  createdATColumn,
  warehouseUsersActionsColumn,
];
